/**
 * Geliştirme ortamında: Sayfa localhost dışında bir IP ile açıldıysa (örn. 10.38.0.118:3001),
 * API adresi aynı host ile 5001 portunda kullanılır; böylece aynı ağdaki cihazlar linki açıp kayıt yapabilir.
 */
export function getApiBaseUrl(): string {
  const env = process.env.REACT_APP_API_URL?.trim();
  if (env) return env.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return `http://${window.location.hostname}:5001`;
  }
  return 'http://localhost:5001';
}
